import React from "react";
import { Box, Button, Paper, Typography } from "@material-ui/core";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import MenuBookIcon from "@material-ui/icons/MenuBook";

const NOTEBOOK_LM_URL =
  "https://notebooklm.google.com/notebook/45abe956-fee7-420e-a30c-ca16f2b91cd9";

/**
 * AIサポート (旧タスクページ置き換え)。
 *
 * Phase 1: NotebookLM への誘導ボタン
 *   Google 側の X-Frame-Options 制約で iframe 埋め込み不可のため、
 *   新しいタブで開いてもらう。
 *
 * Phase 2 (将来): tasteck 内包 AI (Claude API + MCP)
 *   マニュアル + 実データ参照で NotebookLM を超越する。
 */
const AISupport: React.FC = () => {
  const openNotebookLM = () => {
    window.open(NOTEBOOK_LM_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      padding={4}
      style={{ gap: 24 }}
    >
      <Paper
        elevation={3}
        style={{
          padding: 40,
          maxWidth: 720,
          width: "100%",
          textAlign: "center",
          background: "linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%)",
        }}
      >
        <HelpOutlineIcon style={{ fontSize: 64, color: "#1976d2" }} />
        <Typography
          variant="h4"
          style={{ fontWeight: "bold", marginTop: 12, marginBottom: 8 }}
        >
          AIサポート
        </Typography>
        <Typography
          variant="body1"
          color="textSecondary"
          style={{ marginBottom: 24 }}
        >
          操作方法や設定のわからないことを、AI にチャットで質問できます。
          <br />
          マニュアルの内容を元に、24時間いつでも回答します。
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          startIcon={<OpenInNewIcon />}
          onClick={openNotebookLM}
          style={{ padding: "12px 32px", fontSize: 16 }}
        >
          AIチャットを開く
        </Button>
        <Typography
          variant="caption"
          display="block"
          color="textSecondary"
          style={{ marginTop: 12 }}
        >
          新しいタブで開きます（Google NotebookLM）
        </Typography>
      </Paper>

      <Paper
        elevation={1}
        style={{
          padding: 24,
          maxWidth: 720,
          width: "100%",
          backgroundColor: "#fffef5",
          borderLeft: "4px solid #ffa726",
        }}
      >
        <Box display="flex" alignItems="center" style={{ gap: 12 }}>
          <MenuBookIcon style={{ color: "#ffa726" }} />
          <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
            よくある質問例
          </Typography>
        </Box>
        <Box component="ul" style={{ marginTop: 8, paddingLeft: 20 }}>
          <li>
            <Typography variant="body2">予約の新規登録方法は？</Typography>
          </li>
          <li>
            <Typography variant="body2">キャストの登録方法は？</Typography>
          </li>
          <li>
            <Typography variant="body2">LINE連携の設定方法は？</Typography>
          </li>
          <li>
            <Typography variant="body2">精算書の出力方法は？</Typography>
          </li>
          <li>
            <Typography variant="body2">プラン変更はどこから？</Typography>
          </li>
        </Box>
      </Paper>

      <Typography variant="caption" color="textSecondary" align="center">
        ※ 今後、tasteck 内で直接回答できる AI チャット機能を準備中です
      </Typography>
    </Box>
  );
};

export default AISupport;
